/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable consistent-return */
import React, {useEffect, useMemo, useRef, useState, useCallback} from 'react';
import {
  ArtistAboutDetails,
  ArtistDescription,
  BigImage,
  Box,
  ColumnText,
  CoverImage,
  HeroNFT,
  NFTEmailSignUp,
  NftGridList,
  NFTTrackCard,
  ProfileHeader,
  WrapTextWithImage,
} from '@ttx/design-system';
import {GetStaticPaths, GetStaticProps} from 'next';
import Head from 'next/head';
import {ResultOf} from '@graphql-typed-document-node/core';
import {renderMetaTags, SeoMetaTagType} from 'react-datocms';
import {useBreakpoint} from '@ttx/design-system/src/use-breakpoint';
import {request} from '../../graphql/api';
import {
  ArtistDocument,
  AllArtistsDocument,
  StaticNftRecord,
  StaticNftWithUrlRecord,
} from '../../graphql/generated';
import {NextPageWithPageLayoutOptions} from '../../components/page-layout/types';
import {ScrollMarqueeCountdown} from '../../components/scroll-marquee-countdown';
import {NFTTrackHorizontalScroll} from '../../components/nft-track-horizontal-scroll';
import {useTtxMutation} from '../../hooks/ttx-trpc';
import {WalletNetwork} from '../../contexts/authentication-context/types';
import {BlockchainPropsWrapper} from '../../components/blockchain-props-wrapper';
import {QuoteBlockAnimation} from '../../components/quote-block-animation';
import {isElementInView} from '../../utils';
import {useEmailSignup} from '../../hooks/use-email-signup';
import {getOpenseaUrl} from '../../contexts/authentication-context/consts';
import {MAX_NFT_GRID_COLUMNS, MIN_NFT_GRID_COLUMNS} from '../../utils/consts';
import {TabViewInfo} from '../../components/artist-details/tab-view-info';
import {NoNft} from '../../components/no-nft/no-nft';
// import {post} from '../../server/fetch/fetch';
// import {endpoint} from '../../server/fetch/ttx-api-server';
// import {
//   Collection,
//   CollectionListResponse,
// } from '../../server/router/collection/types';
import {CollectionNFTView} from '../../components/artist-details/collection-nft-view';
import {PerksListPage} from '../../components/artist-details/perks-list-page';
import {
  LOCAL_STORAGE_KEY,
  LocalStroageUtil,
} from '../../utils/local-storage-utils';

const ArtistPage: NextPageWithPageLayoutOptions<
  | {
      artist: ResultOf<typeof ArtistDocument>['artist'];
      slug: string;
      site: ResultOf<typeof ArtistDocument>['site'];
    }
  | Record<string, never>
> = (props) => {
  const [animationTriggered, setAnimationTriggered] = useState(false);
  const [activeRelease, setActiveRelease] = useState(0);
  const quoteBlockRef = useRef(null);
  const {currentBreakpoint} = useBreakpoint();
  const isMobile = currentBreakpoint === '768px';

  const onScroll = () => {
    if (
      !animationTriggered &&
      quoteBlockRef.current &&
      isElementInView(quoteBlockRef.current)
    ) {
      setAnimationTriggered(true);
      document.removeEventListener('scroll', onScroll, true);
    }
  };

  useEffect(() => {
    if (LocalStroageUtil.getItem(LOCAL_STORAGE_KEY.ARTIST_FLOW)) {
      setActiveRelease(1);
      LocalStroageUtil.setItem(LOCAL_STORAGE_KEY.ARTIST_FLOW, '');
    }
  }, [LOCAL_STORAGE_KEY.ARTIST_FLOW]);

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true);
    return () => {
      document.removeEventListener('scroll', onScroll, true);
    };
  }, []);

  const {...perksListMutation} = useTtxMutation('collection.artist-perks');

  const {isLoading, ...collectionListMutation} =
    useTtxMutation('collection.list');

  useEffect(() => {
    if (!props.slug) return;
    const perks = LocalStroageUtil.getItem('perks');
    if (perks) {
      LocalStroageUtil.removeItem('perks');
      setActiveRelease(2);
    }
    collectionListMutation.mutate({
      limit: 0,
      page: 1,
      creator: undefined,
      collectionStatus: ['minted', 'draft'],
      nftStatus: ['minted', 'draft'],
      artistSlug: props.slug,
      includeFeatures: true,
      isCollaborators: false,
    });

    perksListMutation.mutate({
      artistSlug: props.slug,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.slug]);

  const latestCollection = useMemo(
    () =>
      collectionListMutation.data
        ?.filter((item) => item.creatorDetails.user.slug === props.slug)
        .shift(),
    [collectionListMutation.data, props.slug],
  );

  const firstItemInLatestCollection = latestCollection?.nftTokenIds[0];

  const {onSignupSubmit} = useEmailSignup({
    collectionId: latestCollection?._id
      ? latestCollection?._id.toString()
      : props.slug,
    artistSlug: props.slug,
  });

  const data = useMemo(
    () =>
      latestCollection
        ? latestCollection.nftTokenIds.map((item) => ({
            ...item,
            network: latestCollection.blockchainNetworkDetail.network,
            contractAddress: latestCollection.contractAddress,
            multiCopy: latestCollection.multiCopy,
          }))
        : [],
    [latestCollection],
  );
  const creatorName = latestCollection?.creatorDetails.user.displayName || '';
  const network = latestCollection?.blockchainNetworkDetail.network;

  const nextDropDate = useMemo(
    () =>
      latestCollection?.mintedAtUTC
        ? new Date(latestCollection.mintedAtUTC)
        : null,
    [latestCollection?.mintedAtUTC],
  );

  const renderItem = useCallback((item: (typeof data)[number]) => {
    return (
      <BlockchainPropsWrapper
        multiCopy={item.multiCopy}
        network={item.network}
        type={item.type}
        nftToken={item}
      >
        <NFTTrackCard
          key={item._id}
          src={item.image || 'src'}
          artist=""
          trackName={item.name}
          isVideo={item.isVideo}
          openseaUrl={getOpenseaUrl(
            item.network,
            item.contractAddress,
            item.tokenId,
          )}
        />
      </BlockchainPropsWrapper>
    );
  }, []);

  const {artist, site} = props;
  const sections = artist?.sections;
  const getHeader = () => {
    if (!sections?.length) {
      return fallbackPageSections;
    }
    const coverImages: any = sections?.find(
      (e) => e.__typename === 'CoverImageRecord',
    );
    const artistProfileHeader: any = sections?.find(
      (e) => e.__typename === 'ArtistProfileHeaderRecord',
    );
    if (coverImages && artistProfileHeader) {
      return (
        <>
          <Box key={coverImages.id}>
            <CoverImage
              image={coverImages?.image?.url}
              logo={coverImages?.logo?.url}
            />
          </Box>
          <Box key={artistProfileHeader.id}>
            <ProfileHeader
              image={artistProfileHeader.image?.url}
              artistName={artist?.artistName}
              instagramHandle={artist?.instagram}
              twitterHandle={artist?.twitter}
              youtubeHandle={artist?.youtube}
              scrollComponent={
                <ScrollMarqueeCountdown
                  artistName={artist?.artistName}
                  collectionName={
                    latestCollection?.title ||
                    artistProfileHeader?.collectionName ||
                    ''
                  }
                  nextDropDate={
                    nextDropDate || artistProfileHeader?.latestDrop
                      ? new Date(artistProfileHeader?.latestDrop)
                      : null
                  }
                />
              }
            />
          </Box>
        </>
      );
    }
  };

  const cmsPageSections = [
    sections?.map((section) => {
      switch (section?.__typename) {
        // case 'CoverImageRecord':
        //   return (
        //     <Box key={section.id}>
        //       <CoverImage image={section.image?.url} logo={section.logo?.url} />
        //     </Box>
        //   );
        // case 'ArtistProfileHeaderRecord':
        //   return (
        //     <Box key={section.id}>
        //       <ProfileHeader
        //         image={section.image?.url}
        //         artistName={artist?.artistName}
        //         instagramHandle={artist?.instagram}
        //         twitterHandle={artist?.twitter}
        //         youtubeHandle={artist?.youtube}
        //         scrollComponent={
        //           <ScrollMarqueeCountdown
        //             artistName={artist?.artistName}
        //             collectionName={
        //               latestCollection?.title || section.collectionName || ''
        //             }
        //             nextDropDate={
        //               nextDropDate || section.latestDrop
        //                 ? new Date(section.latestDrop)
        //                 : null
        //             }
        //           />
        //         }
        //       />
        //     </Box>
        //   );
        // case 'LatestDropRecord':
        //   return latestCollection ? (
        //     <Box key={section.id}>
        //       <NFTTrackHorizontalScroll
        //         isLoading={isLoading}
        //         header="Latest Drop"
        //         data={data}
        //         network={network}
        //         multiCopy={!!latestCollection?.multiCopy}
        //         creatorName={data[0].properties.artist || artist?.artistName}
        //         type={latestCollection?.type}
        //       />
        //     </Box>
        //   ) : null;
        case 'TextWrappedImageRecord':
          return (
            <Box key={section.id}>
              <WrapTextWithImage
                havePaddingTop={false}
                bodyText1={section.text1}
                bodyText2={section.text2}
                bodyText3={section.text3}
                image={section.image?.url}
                imageAlt={section.image?.alt}
              />
            </Box>
          );
        case 'ArtistQuoteRecord':
          return (
            <Box key={section.id} ref={quoteBlockRef}>
              <QuoteBlockAnimation
                playAnimation={animationTriggered}
                quoteText={section.quote || ''}
                quoteArtist={artist?.artistName || ''}
              />
            </Box>
          );
        case 'FullWidthImageRecord':
          return (
            <Box key={section.id}>
              <BigImage
                image={section.image?.url}
                backgroundPosition={
                  section.backgroundPosition as
                    | 'center'
                    | 'bottom'
                    | 'top'
                    | 'right'
                    | 'left'
                }
                backgroundSize={section.backgroundSize as 'cover' | 'contain'}
              />
            </Box>
          );
        case 'TwoColumnTextBlockRecord':
          return (
            <Box key={section.id}>
              <ColumnText
                column1Text={section.textBlock1}
                column2Text={section.textBlock2}
              />
            </Box>
          );
        case 'AboutArtistRecord':
          return (
            <Box key={section.id}>
              <ArtistAboutDetails
                thumbnail={artist?.image?.url}
                artistName={artist?.artistName}
                bio={artist?.bio}
                fontSizeArtistDescription={artist?.fontSizeArtistDescription}
                instagramHandle={artist?.instagram}
                twitterHandle={artist?.twitter}
                youtubeHandle={artist?.youtube}
              />
            </Box>
          );
        case 'NftEmailCaptureRecord':
          return (
            <Box key={section.id}>
              <NFTEmailSignUp
                image={section.image?.url}
                header={section?.title}
                formText={section?.emailSectionHeader}
                onSignupSubmit={onSignupSubmit}
                apiKey={process.env.NEXT_PUBLIC_RECAPTCHA}
              />
            </Box>
          );
        case 'ComingSoonNftsBlockRecord':
          if (section.enableOnAllNft) return null;
          const nfts: StaticNftRecord[] | StaticNftWithUrlRecord[] =
            section.nfts as any;
          return (
            <Box key={section.id}>
              <NFTTrackHorizontalScroll
                isLoading={false}
                isStaticData
                header={section.title}
                subheader={section.subtitle}
                data={nfts}
                network={section.network as WalletNetwork}
                creatorName={artist?.artistName}
                multiCopy
              />
            </Box>
          );
        // case 'HeroNftRecord':
        //   return firstItemInLatestCollection ? (
        //     <Box key={section.id}>
        //       <BlockchainPropsWrapper
        //         nftToken={firstItemInLatestCollection}
        //         multiCopy={latestCollection.multiCopy}
        //         network={latestCollection.blockchainNetworkDetail.network}
        //         type={latestCollection.type}
        //       >
        //         <HeroNFT
        //           image={firstItemInLatestCollection?.image}
        //           header={data[0].properties.artist || creatorName}
        //           subheader={firstItemInLatestCollection?.name}
        //           scrollText={section.scrollingMessage}
        //           description={firstItemInLatestCollection?.description}
        //           buttonCta={section.buttonCta}
        //           dateAdded={new Date(firstItemInLatestCollection.createdAtUTC)}
        //         />
        //       </BlockchainPropsWrapper>
        //     </Box>
        //   ) : null;
        default:
          return null;
      }
    }),
  ].filter(Boolean);

  const aboutPage = () => {
    return (
      <>
        {artist?.artistDescription && artist.artistDescriptionImage ? (
          <ArtistDescription
            image={artist.artistDescriptionImage.url}
            description={artist.artistDescription}
          />
        ) : null}
        {cmsPageSections}
      </>
    );
  };

  const fallbackPageSections = useMemo(() => {
    return (
      <Box>
        <CoverImage
          image={latestCollection?.backgroundImage}
          artistName={creatorName}
        />
        <ProfileHeader
          image={latestCollection?.creatorDetails.user.image}
          artistName={creatorName}
          scrollComponent={
            <ScrollMarqueeCountdown
              artistName={creatorName}
              collectionName={latestCollection?.title || ''}
              nextDropDate={nextDropDate}
            />
          }
        />
        {/* <NFTTrackHorizontalScroll
          isLoading={isLoading}
          header="Latest Drop"
          data={data}
          network={network}
          multiCopy={!!latestCollection?.multiCopy}
          creatorName={creatorName}
          type={latestCollection?.type}
        /> */}
      </Box>
    );
  }, [creatorName, data, isLoading, latestCollection, network, nextDropDate]);

  const getAllNFTView = () => {
    const heroNFTRecord: any = sections?.find(
      (e) => e.__typename === 'HeroNftRecord',
    );
    const comingSoonNftsBlockRecord: any = sections?.find(
      (e) => e.__typename === 'ComingSoonNftsBlockRecord',
    );
    if (heroNFTRecord && data.length === 1 && firstItemInLatestCollection) {
      return (
        <Box key={heroNFTRecord.id} mt="eight">
          <BlockchainPropsWrapper
            nftToken={firstItemInLatestCollection}
            multiCopy={latestCollection.multiCopy}
            network={latestCollection.blockchainNetworkDetail.network}
            type={latestCollection.type}
          >
            <HeroNFT
              image={firstItemInLatestCollection?.image}
              header={data[0].properties.artist || creatorName}
              subheader={firstItemInLatestCollection?.name}
              scrollText={heroNFTRecord.scrollingMessage}
              description={firstItemInLatestCollection?.description}
              buttonCta={heroNFTRecord.buttonCta}
              dateAdded={new Date(firstItemInLatestCollection.createdAtUTC)}
            />
          </BlockchainPropsWrapper>
        </Box>
      );
    }
    if (
      comingSoonNftsBlockRecord &&
      data.length === 0 &&
      comingSoonNftsBlockRecord.enableOnAllNft
    ) {
      const nfts: StaticNftRecord[] | StaticNftWithUrlRecord[] =
        comingSoonNftsBlockRecord.nfts as any;
      return (
        <Box key={comingSoonNftsBlockRecord.id}>
          <NFTTrackHorizontalScroll
            isLoading={false}
            isStaticData
            header={comingSoonNftsBlockRecord.title}
            subheader={comingSoonNftsBlockRecord.subtitle}
            data={nfts}
            network={comingSoonNftsBlockRecord.network as WalletNetwork}
            creatorName={artist?.artistName}
            multiCopy
          />
        </Box>
      );
    }
    if (data.length === 0) {
      return (
        <NoNft
          title="This artist doesn’t have any NFTs yet."
          subtitle="Find out more about their work here"
        />
      );
    }
    return (
      <NftGridList
        columns={
          data.length > 4 || isLoading
            ? MAX_NFT_GRID_COLUMNS
            : MIN_NFT_GRID_COLUMNS
        }
        rowSpace="xxs"
        columnSpace="xxs"
        keyExtractor={(item: {_id: string}) => item._id}
        loading={isLoading}
        items={data}
        error=""
        renderItem={renderItem}
      />
    );
  };

  const tabViewPageSections = useMemo(() => {
    return (
      <Box>
        {getHeader()}
        <TabViewInfo
          isMobile={isMobile}
          activeRelease={activeRelease}
          tabData={[
            // {
            //   title: 'All NFTs',
            //   component: getAllNFTView(),
            // },
            {title: 'About', component: aboutPage()},
            {
              title: 'Releases',
              component: (
                <CollectionNFTView
                  isMobile={isMobile}
                  collectionList={collectionListMutation.data || []}
                  nftView={getAllNFTView()}
                />
              ),
            },
            {
              title: 'Perks',
              component:
                perksListMutation.data && perksListMutation.data.length > 0 ? (
                  <PerksListPage
                    artistSlug={props.slug}
                    artistDetails={props.artist}
                    perksListMutation={perksListMutation.data || []}
                  />
                ) : (
                  <NoNft
                    title="This artist has not setup any perks yet"
                    subtitle="Watch this space for future perks from the artist"
                  />
                ),
            },
          ]}
        />
      </Box>
    );
  }, [cmsPageSections, activeRelease]);

  return (
    <Box>
      <Head>
        <title>{artist?.artistName}</title>
      </Head>
      <Head>
        {renderMetaTags(
          (artist?.seo?.concat(site?.favicon || []) || []) as SeoMetaTagType[],
        )}
      </Head>
      <Box
        borderBottomColor="grey24"
        borderBottomWidth="one"
        borderBottomStyle="solid"
      >
        {/* {cmsPageSections.length ? cmsPageSections : fallbackPageSections} */}
        {tabViewPageSections}
      </Box>
    </Box>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const result = await request(AllArtistsDocument);

  return {
    fallback: true,
    paths: result.allArtists
      .filter((page) => page.slug)
      .map((page) => ({
        params: {
          slug: page.slug as string,
        },
      })),
  };
};

export const getStaticProps: GetStaticProps<any, {slug: string}> = async ({
  params,
  preview,
}) => {
  if (!params) return {props: {}};
  const artistResult = await request(
    ArtistDocument,
    {slug: params.slug},
    preview,
  );

  return {
    revalidate: 60,
    props: {
      artist: artistResult.artist,
      slug: params.slug,
      preview: preview ?? false,
      site: artistResult.site,
    },
  };
};

ArtistPage.pageLayoutOptions = {
  showFooter: true,
};

export default ArtistPage;
